<div class="dialogContainer">
  <div class="header">
    <h2>Generate Documents</h2>
  </div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
  <div class="content">
    @if (documentOptions) {
      <div class="tableWrapper">
        <div class="lineSelectionOptions">
          <mat-radio-group [(ngModel)]="lineSelection">
            <mat-radio-button (change)="clearLineSelection()" value="all" class="optionValue">All Lines</mat-radio-button>
            <mat-radio-button class="optionValue" value="selected">Selected Lines</mat-radio-button>
          </mat-radio-group>
          @if (lineSelection === 'selected') {
            <button matButton="text" (click)="selectLines()">Select</button>
          }
          @if (lineSelection === 'selected') {
            <div class="selectedLineDisplay">
              {{ selectedLines() }}
            </div>
          }
        </div>
        <table class="reportTable">
          <thead>
            <tr>
              <td class="tableCell centeredCell headerCell checkboxCell" (click)="toggleAllSelections()">
                <input type="checkbox" [checked]="allItemsSelected()"/>
              </td>
              <td class="tableCell headerCell">Document Type</td>
              <td class="tableCell headerCell">Format</td>
            </tr>
          </thead>
          @for (documentOption of documentOptions; track documentOption) {
            <tr>
              <td class="tableCell centeredCell" (click)="updateSelection(documentOption)"
                [matTooltip]="getTooltip(documentOption)">
                <input type="checkbox" [checked]="isSelected(documentOption)"/>
              </td>
              <td [matTooltip]="getTooltip(documentOption)" class="tableCell">
                {{ documentOption.displayName }}
              </td>
              <td class="tableCell" [matTooltip]="getTooltip(documentOption)">
                <select class="userInput" [(ngModel)]="documentOption.documentFormat">
                  @for (format of documentOption.availableFormats; track format) {
                    <option [value]="format">{{ format }}</option>
                  }
                </select>
              </td>
            </tr>
          }
        </table>
      </div>
    }
    @if (errorMessage()) {
      <div class="errorMessage">
        {{ errorMessage() }}
      </div>
    }
  </div>
  <div mat-dialog-actions>
    @if (!isSchedule()) {
      <button matButton="elevated"
        matTooltip="Generates one PDF Submittal to include checked documents"
        [disabled]="isBusy() || selectedDocuments.length === 0" (click)="generateSubmittalPackage()">
        Generate submittal package
      </button>
    }
    <span class="spacer"></span>
    <button matButton="elevated"
      matTooltip="Generates individual document for each checked document"
      [disabled]="isBusy() || selectedDocuments.length === 0" (click)="saveAndClose()">
      Generate
    </button>
    <button matButton="elevated" (click)="cancel()">Cancel</button>
  </div>
</div>
